import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AccountService from "../Services/accountService"; // adapte le chemin
import { useToasts } from "../LayoutComponents/ToastContext"; // optionnel
import LoadingSpinner from "../LayoutComponents/LoadingSpinner";

const UpgradeCheckoutSuccess = () => {
  const navigate = useNavigate();
  const { addToast } = useToasts();

  useEffect(() => {
    const handleUpgrade = async () => {
      try {
        localStorage.removeItem("token");
        setTimeout(() => {
          navigate("/login?upgraded");
        }, 1500);
      } catch (err) {
        console.error("Erreur UpgradeSubscription:", err);
        addToast(
          "Un problème est survenu. Votre paiement est reçu, mais le compte sera activé sous peu.",
          "UPGRADE_ERROR",
          "WARNING",
          true,
        );
        navigate("/login?upgraded");
      }
    };

    handleUpgrade();
  }, [navigate, addToast]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}>
      <LoadingSpinner size={60} />

      {/*<h1>Paiement réussi 🎉</h1>
      <p>Nous finalisons la mise à niveau de votre compte...</p>
      */}
    </div>
  );
};

export default UpgradeCheckoutSuccess;
